import React from "react"
import { Link } from "gatsby"

import { camelize } from "components/utils"
import Svg from "components/svgs/svg"

import cx from "classnames"
import * as s from "./header.module.sass"

const Header = (props) => {
  const { version, parentClass } = props

  const componentClass = cx({
    [s.component]: true,
    [s[camelize(`version-${version}`)]]: version,
    [parentClass]: parentClass,
  })

  const svgId = version === "index" ? "nsLogoLight" : "nsLogo"

  return (
    <div className={componentClass}>
      <Link to={`${process.env.SITE_URL}/`} className={s.logo}>
        <Svg parentClass={s.svg} id={svgId} />
      </Link>
    </div>
  )
}

export default Header
